module.exports = __webpack_public_path__ + "static/media/citadele-logo.84a8eaed.svg";